module.exports = __webpack_public_path__ + "3d7a2426cd95e6a9e4bcd6638ff4a0ba.svg";